import { useFormik } from 'formik';
import PropTypes from 'prop-types';
//import material
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import { FormControl, FormHelperText } from '@mui/material';
//import style
import { DialogTitle, DialogContent, DialogActions, ModalColumna } from './cuentasComponents';
import { movimientoValidationSchema } from './validation';
import { styles } from './cuentasComponents';
import GenericTextField from '../../components/generics/GenericTextField';
import GenericNativeSelect from '../../components/generics/GenericNativeSelect';
import { useContext, useState } from 'react';
import { crearNuevoMovimiento } from '../../services/CuentasCorrientesService';
import { AdminContext } from '../../context/AdminContext';
import { SNACKBAR_SEVERITY } from '../../constants';

function ModalCuentas({ modal, closeModal, selectedUser }) {
  const classes = styles;
  const { handleClickSnackbar } = useContext(AdminContext);
  const [loading, setLoading] = useState(false)
  const initialValues = { montoProveedor: 0, descripcion: '', tipoMovimiento: 'AGREGAR', tipoDeSaldo: "saldoEfectivo", UserId: selectedUser?.identificador };

  async function crearMovimiento(movimiento) {
   return await crearNuevoMovimiento(movimiento);
  }

  const formik = useFormik({
    initialValues,
    validationSchema: movimientoValidationSchema,
    onSubmit: async values => {
      if (loading) return;
      setLoading(true);
      const resultado = await crearMovimiento(values);
      if (resultado) handleClickSnackbar("Movimiento creado con exito", SNACKBAR_SEVERITY.info);
      else handleClickSnackbar("No se pudo crear el movimiento", SNACKBAR_SEVERITY.error);
      formik.resetForm();
      await closeModal();
      setLoading(false)
    },
    enableReinitialize: true,
  });

  const handleClose = () => {
    formik.resetForm();
    closeModal();
  };

  return (
    <div>
      <Dialog onClose={handleClose} open={modal} maxWidth='xl'>
        <form onSubmit={formik.handleSubmit} className={classes.form}>
          <DialogTitle id='customized-dialog-title' onClose={handleClose}>
            {selectedUser?.nombreCompleto}
          </DialogTitle>

          <DialogContent dividers>
            <ModalColumna>
              <GenericTextField formik={formik} campo={'montoProveedor'} />
              <FormControl variant="standard">
                <GenericNativeSelect formik={formik} field='tipoMovimiento'>
                  <option value={'AGREGAR'}>AGREGAR</option>
                  <option value={'RETIRAR'}>RETIRAR</option>
                </GenericNativeSelect>
                <FormHelperText>Elija el tipo de movimiento que desea  crear</FormHelperText>
              </FormControl>
              <FormControl variant="standard" className={classes.formControl}>
                <GenericNativeSelect formik={formik} field='tipoDeSaldo'>
                  <option value={'saldoEfectivo'}>Efectivo</option>
                  <option value={'saldoCredito'}>Credito</option>
                </GenericNativeSelect>
                <FormHelperText>Elija el tipo de saldo que desea modificar</FormHelperText>
              </FormControl>
              <GenericTextField formik={formik} campo={'descripcion'} />

            </ModalColumna>
          </DialogContent>
          <DialogActions>
            <Button color='primary' variant='contained' type='submit'>
              Crear Movimiento
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ModalCuentas.propTypes = {
  modal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedUser: PropTypes.object,
};

export default ModalCuentas;
